module.exports = __webpack_public_path__ + "static/media/dobrenarty.ff92d0df.jpg";